<template>
    <!-- visible -->
    <div class="pagex">
        <!-- <van-popup :class="position == 'right' ? 'one' : 'onePc'" v-model="visible" :position="position == 'right' ? 'right' : 'center'"> -->
        <div class="one_body" v-if="!isWpage">
            <div v-if="page == 'index'">
                <img class="imge" src="../../../assets/image/one/logo.png" alt="">
                <div class="title flex">
                    <div class="title_t">
                        <span>{{ $t('new14') }}</span>
                        <div></div>
                    </div>
                    <div class="title_r" @click="onPagesWon('hunt_newRule')">{{ $t('hunt65') }}>></div>
                </div>
                <div class="price">
                    <div class="price_title">
                        <div>{{ $t('yi2') }}</div>
                        <div class="more" @click="onPagesWon('usd_page')">{{ $t('yi15') }}</div>
                    </div>
                    <div class="price_body">
                        <div v-for="el in UsdList" :key="el" @click="onPages('des', el)">
                            <span>{{ el }}USD</span>
                        </div>
                    </div>
                </div>

                <div class="run">
                    <!-- <div @click="onPageGo('HuntNotes')">{{ $t('yi4') }}</div> -->
                    <div @click="onPagesWon('hunt_notes')">{{ $t('yi4') }}</div>

                    <div @click="onPages('notes')">{{ $t('yi5') }}</div>

                    <!-- position -->
                    <!-- <div @click="onPagesWon('hunt_cashNew')">{{ $t('yi6') }}</div> -->
                    <!-- <div @click="onPagesWon('hunt_cashNew')" v-if="position == 'right'">{{ $t('yi6') }}</div> -->
                    <!-- <div @click="onPageGo('HuntIndex')">{{ $t('new25') }}</div> -->
                    <div @click="onPagesWon('withdraw_list')">{{ $t('yi7') }}</div>
                    <div @click="onPagesWon('recharge_list')">{{ $t('yi8') }}</div>
                    <!-- <div @click="onPagesWon('convert')">{{ $t('hunt4') }}</div> -->
                    <div @click="onPagesWon('commission')">{{ $t('MyCommission') }}</div>
                    <div @click="onPagesWon('points')">{{ $t('Points Logs') }}</div>
                    <!-- <div @click="onPagesWon('hunt_newRule')">{{ $t('hunt65') }}</div> -->
                    <div @click="onPagesWon('shipping')">{{ $t('hunt17') }}</div>
                    <div @click="onPagesWon('my_team')">{{ $t('MyTeam') }}</div>
                    <!-- <div @click="onPagesWon('guide_index')">{{ $t('guide.Rewards') }}</div> -->
                </div>
            </div>
            <Des @onPage="onBackIndexOrUsdPage" :val="usd" :valAct="valAct" v-if="page == 'des'" ref="RefDes" />
            <Notes @onPage="onGoto" @onPagesWon="onPagesWon" @onPageData="onPageData" :val="usd" v-if="page == 'notes'" />
        </div>
        <div class="one_body pagePc" v-else>
            <!-- 奖励介绍-邀请 -->
            <!-- <Inviter @onPage="onPagesWon" :one="true" v-if="page == 'inviter'"/> -->
            <!-- 奖励介绍 -->
            <!-- <GuideIdex @onPage="onBackGuide" :one="true" v-if="page == 'guide_index'" /> -->
            <!-- 更多专区 -->
            <UsdPage @onPage="onBackIndexOrDes" :one="true" v-if="page == 'usd_page'" />
            <!-- 夺宝记录 -->
            <HuntNotes @onPage="onGoto" :one="true" v-if="page == 'hunt_notes'" />
            <!-- 查看兑换码 -->
            <HuntCashNew @onPage="onGoto" :one="true" :objData="objData" v-if="page == 'hunt_cashNew'" />
            <!-- 规则 -->
            <HuntNewRule @onPage="onGoto" :one="true" v-if="page == 'hunt_newRule'" />
            <!-- 提现 -->
            <MemberWithdrawList @onPage="onGoto" :one="true" v-if="page == 'withdraw_list'" />
            <!-- 充值 -->
            <RechargeList @onPage="onGoto" :one="true" v-if="page == 'recharge_list'" />
            <!-- 寄货规则 -->
            <Shipping  @onPage="onGoto" :one="true" v-if="page == 'shipping'" />
            <!-- 我要兑换 -->
            <Convert @onPage="onGoto" :one="true" :objData="slayDate" v-if="page == 'convert'" />
            <!-- 我的佣金 -->
            <Commission @onPage="onGoto" :one="true" v-if="page == 'commission'" />
            <!-- 我的积分 -->
            <Points @onPage="onGoto" :one="true" v-if="page == 'points'" />
            <!-- 收货 -->
            <Pickup @onPage="onGoto" :one="true" :objData="slayDate" v-if="page == 'pickup'" />
            <!-- 我的团队 -->
            <MyTeam @onPage="onGoto" :one="true" :objData="slayDate" v-if="page == 'my_team'" />
        </div>
        <buyDialog :show="showModal" @updateShow="updateShow" @onPagesWon="onPagesWon" :objData="slayDate" :BuyType="false" :isWin="isWin"
            @onPage="onGoto" />
        <!-- </van-popup> -->
    </div>
</template>

<script>
// import Inviter from '../../member/inviter/InviterManage.vue'
import Des from './des.vue'
import BuyDialog from './buyDialog.vue'
import Notes from './notes.vue'
import HuntNotes from '../hunt/notes.vue'
import HuntCashNew from '../hunt/cashNew.vue'
import HuntNewRule from '../hunt/newRule.vue'
import MemberWithdrawList from './WithdrawList.vue'
import RechargeList from './RechargeList'
import Shipping from '../hunt/shipping.vue'
import Convert from '../hunt/convert.vue'
import Commission from '../one/Commission.vue'
import Points from '../point/PointList.vue'
import Pickup from './Pickup.vue'
import MyTeam from './MyTeam.vue'
import UsdPage from './UsdPage.vue'
// import GuideIdex from '../../home/guide/index.vue'

import { vitiList, GetLatestLotteryInfo, GetCycleList } from '../../../api/memberOne'
import store from "../../../store";
export default {
    name: 'Hunt',
    props: {
        visible: {
            default: false,
            type: Boolean
        },
        position: {
            default: 'right',
            type: String
        }
    },
    components: {
        Des,
        BuyDialog,
        Notes,
        HuntNotes,
        HuntCashNew,
        HuntNewRule,
        MemberWithdrawList,
        RechargeList,
        Shipping,
        Convert,
        Points,
        Commission,
        Pickup,
        MyTeam,
        UsdPage,
        // GuideIdex,
        // Inviter
    },
    data() {
        return {
            manualClose: false,  // 是否为手动断开连接
            pongTimeout: null,   // 等待pong的计时器
            canReconnect: true,
            timeOut: null,
            lockReconnect:false,
            socket: null,
            socket_connect: 0, // WebSocket 连接状态
            isShow: this.visible,
            page: 'index',
            UsdList: [],
            val: '',
            valAct: 'index',
            objData: {},
            slayDate: {},
            usd: '',
            showModal: false,
            member_id: '',
            isWin: true,
            isWpage: false,
            isX: true
        }
    },
    watch: {
        $route(to, from) {}
    },
    created() {
        this.getUsdList()
        this.createWebSocket();
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('is_rule') === '1'){
            this.onPagesWon('hunt_newRule')
        }
    },
    beforeDestroy() {
        this.manualClose = true;
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
        heartCheck.stop();
    },
    methods: {
        createWebSocket() {
            if (this.socket_connect === 1) {
                console.log("WebSocket 已连接，跳过创建");
                return;
            }

            const currentDomain = window.location.origin;
            let ws_url = currentDomain.includes('goshop.shop') ? env.WS_URL : env.WS_URL1;

            try {
                this.socket = new WebSocket(ws_url);
                this.init();
            } catch (e) {
                console.log("WebSocket 创建失败:", e);
                this.reconnect();
            }
        },
        init() {
            if (!this.socket) return;
            this.socket.onopen = this.wsOpen;
            this.socket.onmessage = this.wsMessage;
            this.socket.onclose = this.wsClose;
            this.socket.onerror = this.wsError;
        },
        wsOpen(){
            const param = {
                type: "login",
                activity_type: "luckbuy",
                key: store.state.member.token,
                member_id: store.state.member.info.member_id
            };
            this.socket.send(JSON.stringify(param));
            this.socket_connect = 1;
            heartCheck.start(this.socket, this.reconnect); // 开启心跳检测
        },
        // 接收消息
        wsMessage(res){
            if (res.data === 'pong') {
                heartCheck.receivePong();
                return;
            }

            let res_ = JSON.parse(res.data);
            let data = res_.data;

            if (data.type === 'box_now_info') return;
            if (this.showModal) return;

            if (this.isObjectWithUid(res_)) {
                if (data.type === 'luck_buy_draw') {
                    if (this.page === 'des') {
                        this.callChildMethod('RefDes', 'getUsdActivityList', 1);
                    }
                    this.onGetLatestLotteryInfo();
                }

                if (data.type === 'luck_buy_order') {
                    if (this.page === 'des') {
                        this.callChildMethod('RefDes', 'onUpdateSlotsSold', data);
                    }
                }
            }

            heartCheck.receivePong(); // 接收到任何消息都视作连接正常
        },
        wsClose(res) {
            console.log("WebSocket 关闭", res.reason);
            this.socket_connect = 0;
            heartCheck.stop();
            if (!this.manualClose && this.canReconnect !== false) {
                this.reconnect();
            }
        },
        wsError() {
            console.log("WebSocket 出错");
            heartCheck.stop();
            if (!this.manualClose && this.canReconnect !== false) {
                this.reconnect();
            }
        },
        reconnect() {
            console.log("尝试重连");
            if (this.lockReconnect) return;
            this.lockReconnect = true;
            // 没连接上会一直重连，设置延迟避免请求过多
            if (this.timeOut) clearTimeout(this.timeOut);

            this.timeOut = setTimeout(() => {
                console.log("执行重连...");
                this.createWebSocket();
                this.lockReconnect = false;
            }, 3000);
        },
        isObjectWithUid(data) {
            // 检查 data 是否是对象并且不是 null
            if (typeof data === "object" && data !== null) {
                return true;
            }
            return false;
        },
        onVisible() {
            this.isShow = !this.isShow;
            this.$emit('onVisible', false)
        },
        getVitiList() {
            vitiList({
                price_range: '100,200',
                page: 1,
                limit: 10,
            }, 'one').then(res => {
            }, error => { })
        },
        // 获取usd列表
        getUsdList() {
            if(localStorage.getItem('usd_list')){
                this.UsdList = JSON.parse(localStorage.getItem('usd_list'))
            }else{
                GetCycleList({}, 'one').then(res => {
                    if (res && res.result) {
                        this.UsdList = res.result
                        localStorage.setItem('usd_list', JSON.stringify(res.result));
                    }
                }, error => { })
            }
        },
        //usd_page界面绑定的方法
        onBackIndexOrDes(v, val){
            if(v == 'index'){
                this.isWpage = false
                this.page = 'index'
                this.objData = {}
                this.slayDate = {}
            }else{
                this.valAct = 'usd_page'
                this.onGoto(v, val)
            }
        },
        onBackIndexOrUsdPage(v, val, valAct){
            if(valAct == 'usd_page'){
                this.onPagesWon('usd_page')
            }else{
                this.onGoto(v, val)
            }
        },
        onBackUsdPage(){
            this.onPagesWon('usd_page')
        },
        onBackGuide(v, val){
            if(v == 'index'){
                this.onGoto('index')
            }else{
                this.onPagesWon(v, val)
            }
        },
        onPageGo(name, val) {
            this.$router.push({ name: name, query: { data: val } })
        },
        onGoto(v, val) {
            this.isWpage = false
            if (v == 'x') {
                this.isShow = !this.isShow;
                this.$emit('onVisible', false)
                return
            }
            this.page = v
            this.objData = val || {}
            if(v == 'des') this.usd = val
        },
        onPagesWon(v, val, page = 'index') {
            this.isWpage = true
            this.page = v
            if(val){
                val.page = page ? page : 'index'
                this.objData = val || {}
            }
        },
        onPageData(v, val) {
            this.isWpage = true
            this.page = v
            this.slayDate = val || {}
        },
        onPages(v, val) {
            this.isWpage = false
            this.page = v
            this.usd = val || ''
        },
        // 开奖结果
        updateShow() {
            this.showModal = false
        },
        //调用子组件的方法
        callChildMethod(ref, fun, data) {
            // 通过 this.$refs 访问子组件实例并调用其方法
            if (this.$refs[ref] && typeof this.$refs[ref][fun] === 'function') {
                this.$refs[ref][fun](data);
            }
        },
        // 开奖结果
        onGetLatestLotteryInfo() {
            if(this.showModal) return;
            GetLatestLotteryInfo({}, 'one').then(res => {
                if (res && res.result && res.result.member_id) {
                    this.slayDate = res.result
                    let data = JSON.parse(sessionStorage.getItem('actData')) || []

                    let datax = JSON.parse(localStorage.getItem('gobuy'))
                    const memberxid = datax.member.info.member_id || ''
                    if (res.result.member_id == memberxid) {
                        // 中奖
                        this.isWin = true
                        this.showModal = true
                    } else {
                        // 未中奖
                        this.isWin = false
                        this.showModal = true
                    }
                }
            })
        }
    }
}
// 心跳检测
var heartCheck = {
    timeout: 10000,           // ping间隔
    serverTimeout: 5000,      // 等待pong的最大时长
    pingTimer: null,
    pongTimer: null,
    socket: null,

    start(socket, onTimeout) {
        this.stop();
        this.socket = socket;

        this.pingTimer = setInterval(() => {
            if (this.socket.readyState === WebSocket.OPEN) {
                console.log('发送心跳 ping');
                this.socket.send('ping');

                // 等待 server 的 pong，如果超时则视为断线
                this.pongTimer = setTimeout(() => {
                    console.warn('未收到 pong，连接超时，准备重连');
                    if (typeof onTimeout === 'function') {
                        onTimeout();
                    }
                }, this.serverTimeout);
            }
        }, this.timeout);
    },

    receivePong() {
        if (this.pongTimer) {
            clearTimeout(this.pongTimer);
            this.pongTimer = null;
        }
    },

    stop() {
        clearInterval(this.pingTimer);
        clearTimeout(this.pongTimer);
        this.pingTimer = null;
        this.pongTimer = null;
        this.socket = null;
    }
};
</script>

<style scoped lang="scss">
.more{
    font-size: 13px;
    color: #716c6c;
    cursor: pointer;
    font-weight: normal;
}
.pagex {
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
    height: 100%;
}
.one {
    width: 82%;
    height: 100vh;
    background: rgba(0, 0, 0, 0);
}

.onePc {
    width: 20%;
    min-width: 375px;
    height: 70vh;
    background: rgba(0, 0, 0, 0);
}


.flex {
    display: flex;
}

.pagePc {
    padding: 0 !important;
    // overflow-y: hidden !important;
}

.one_body {
    overflow-y: auto;
    width: 100%;
    height: 100vh;
    background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
    //border-radius: 12px;
    border: 1px solid #F45C1D;
    padding: 15px 20px;
    box-sizing: border-box;
    position: relative;

    .imge {
        position: absolute;
        left: 0;
        width: 50%;
        bottom: 10%;
        transform: translate(50%, 0%);
    }

    .title {
        align-items: center;
        justify-content: space-between;

        .title_t {
            font-size: 14px;
            color: #000;
            font-weight: bold;
            cursor: pointer;

            div {
                width: 100%;
                height: 5px;
                background: linear-gradient(90deg, #F21D19 0%, #FFF5F4 100%);
                border-radius: 8px;
            }
        }
        .title_x {
            cursor: pointer;

            svg {
                width: 20px;
                height: 20px;
            }
        }
    }
    .title_r {
        text-align: right;
        font-size: 13px;
        color: #716c6c;
        cursor: pointer;
    }
    .price {
        margin: 40px 0 20px;
        border: #F9A07B 1px solid;
        border-radius: 10px;
        padding: 10px 5px;
        box-sizing: border-box;
        position: sticky;
        z-index: 999;

        .price_title {
            font-size: 16px;
            color: #333;
            font-weight: bold;
            padding-left: 10px;
            display: flex;
            justify-content: space-between;
            padding-right:10px;
        }

        .price_body {
            padding: 20px 0 0;
            color: #EC3031;
            font-size: 12px;
            display: grid;
            grid-template-columns: repeat(3, 1fr);


            div {
                margin-bottom: 20px;
                text-align: center;
            }

            span {
                cursor: pointer;
                text-decoration: underline;
            }
        }
    }

    .run {
        border: #F9A07B 1px solid;
        border-radius: 10px;
        padding: 20px 10px;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 20px;
        gap: 20px;
        font-size: 12px;
        z-index: 10;
        position: sticky;

        div {
            padding: 10px 0;
            text-align: center;
            font-weight: bold;
            cursor: pointer;
            background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
            border-radius: 5px;
            border: 1px solid #F45C1D;
        }
    }
}
</style>